import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { getDatabase, ref, get } from 'firebase/database';
import { getAuth } from 'firebase/auth';

const containerStyle = {
  width: '100%',
  height: '260px'
};

const defaultMapCenter = {
  lat: 44.46876894118559,
  lng: -73.15235703897328
};

function LocationPicker({ onLocationSelected }) {
  const [position, setPosition] = useState(null);
  const [mapCenter, setMapCenter] = useState(defaultMapCenter);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        setPosition(currentLocation);
        setMapCenter(currentLocation);
        onLocationSelected(currentLocation);
      }, (error) => {
        console.error("Error fetching location", error);
      });
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };
  
  useEffect(() => {
    const fetchUserLocation = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const db = getDatabase();
        const userRef = ref(db, `users/${user.uid}`);
        
        const snapshot = await get(userRef);

        if (snapshot.exists() && snapshot.val().location) {
          setMapCenter(snapshot.val().location);
          setPosition(snapshot.val().location);
        }
      }
    };
    
    fetchUserLocation();
  }, []);

  const handleClick = (e) => {
    const latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    setPosition(latLng);
    onLocationSelected(latLng);
  };

  return (
    <div className="google_maps_map_container">
      <button type="button" className="google_maps_location_button" onClick={getCurrentLocation}>Get Current Location</button>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={13}
        onClick={handleClick}
      >
        {position && <Marker position={position} />}
      </GoogleMap>
    </div>
  );
  
}

export default LocationPicker;
